export default __webpack_public_path__ + "static/assets/c5e54268164eadcafa13b7b5f17ffcb1.png";